import { Helmet, HelmetProvider } from "react-helmet-async";
import { Container } from "react-bootstrap";
import { useState } from "react";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { AiOutlineMail } from "react-icons/ai";
import { FiCopy } from "react-icons/fi";
import "./CSS/About.css";

function About() {
  const [copyLabel, setCopyLabel] = useState("Copy");

  function handleCopy() {
    setCopyLabel("Copied");

    setTimeout(function () {
      setCopyLabel("Copy");
    }, 1000);
  }

  return (
    <>
      <HelmetProvider>
        <Helmet>
          <title>About | Lee</title>
        </Helmet>
      </HelmetProvider>
  
      <Container fluid className="about-container">
        <div className="about-title animate__animated animate__zoomIn">
          <h3>About</h3>
          <h4>
            ───&nbsp;&nbsp;Page <strong>02</strong>
          </h4>
        </div>
        <div className="about-content animate__animated animate__fadeIn animate__slower">
          <div className="about-copy">
            <p className="about-lead">
              I’m a software engineer focused on production systems where correctness, clarity, and long-term
              maintainability matter.
            </p>
            <p>
              Much of my work centers on backend services and data-driven workflows, especially in environments where
              small design decisions compound over time. I prioritize clear boundaries, predictable behaviour, and
              designs that stay understandable as systems evolve.
            </p>
            <p>
              I favor simple, well-structured solutions over unnecessary complexity, and I’m comfortable working across
              the stack when needed, with particular attention to data modelling, integration points, and reliability.
            </p>
          </div>
          <div className="about-contact" aria-label="Contact details">
            <p>For project discussions or professional enquiries:</p>
            <div className="about-contact-actions">
              <a href="mailto:lee@zlaliberte.com" className="about-email">
                <AiOutlineMail aria-hidden="true" />
                lee@zlaliberte.com
              </a>
              <CopyToClipboard text="lee@zlaliberte.com">
                <button className="about-copy-button" onClick={handleCopy}>
                  {copyLabel}
                  <FiCopy aria-hidden="true" />
                </button>
              </CopyToClipboard>
            </div>
          </div>
          <div className="about-divider" role="presentation" />
          <div className="about-grid">
            <div className="about-block">
              <p className="about-label">Focus Areas</p>
              <ul>
                <li>API design and system boundaries</li>
                <li>Relational data modelling and schema evolution</li>
                <li>Integration-heavy, reliability-focused delivery</li>
              </ul>
            </div>
            <div className="about-block">
              <p className="about-label">Working Style</p>
              <ul>
                <li>Bias toward clarity and maintainable defaults</li>
                <li>Pragmatic architecture with tight feedback loops</li>
                <li>Deliverable-first with disciplined documentation</li>
              </ul>
            </div>
            <div className="about-block">
              <p className="about-label">What I Value</p>
              <ul>
                <li>Calm systems with observable behavior</li>
                <li>Interfaces that stay readable under change</li>
                <li>Decisions that scale without rework</li>
              </ul>
            </div>
          </div>
        </div>
      </Container>
    </>
  );
}

export default About;
